<template>
    <v-col cols="12" md="6" lg="4" align="center" class="pl-5">
        <v-card
            class="pa-4 bg-ranking"
            elevation="12"
            to="/user/ranking"
            :height="this.$vuetify.breakpoint.xl?300:350"
        >
            <v-row align="center">
                <v-col cols="7" xl="9" class="white--text text-left text-h5 font-weight-regular">
                    {{ $t('home.ranking') }}
                    <p class="py-2 text-left text-subtitle-1 text-lg-subtitle-1">
                        {{ $t('home.ranking_desc') }}
                    </p>
                </v-col>
            </v-row>
            <v-overlay absolute value="true" opacity="0" class="overlayRanking">
                <v-img src="/img/user/ranking.svg" height="365" width="400"></v-img>
            </v-overlay>
        </v-card>
    </v-col>
</template>

<script>
export default {
    
}
</script>
<style scoped>
.v-card {
    border-radius: 20px;
}

.bg-ranking {
    background: rgb(6,136,212);
    background: linear-gradient(145deg, rgba(6,136,212,1) 0%, rgba(113,196,244,1) 60%, rgba(147,215,255,1) 100%);
}

.overlayRanking {
    justify-content: flex-end;
    margin-bottom: 40px;
    margin-right: -30px;
}

@media (max-width: 1903px) {
    .overlayRanking {
        margin-bottom: -10px;
    }
}
</style>